import React from 'react';
import PropTypes from 'prop-types';
import FetchSelect from '../../../core/form/FetchSelect';
import get from 'lodash/get';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';

const CourseListFilter = (props) => (
  <Row>
    <Column xl={3} xxl={3} lg={4}>
      <FetchSelect
        label="Academic Plan"
        value={get(props.values, 'academicPlan', '')}
        onChange={(name) => {
          props.onChange('academicPlan', name);
          props.onSearch();
        }}
        errorText={get(props.errors, 'academicPlan', '')}
        url="academic-plans"
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
    <Column xl={4} xxl={4} lg={6}>
      <FetchSelect
        url="distributors"
        label="Distributor"
        value={get(props.values, 'distributor', '')}
        onChange={(distributor) => {
          props.onChange('distributor', distributor);
          props.onSearch();
        }}
        errorText={get(props.errors, 'distributor', '')}
        resultTransformer={{
          text: 'name',
          value: 'id',
        }}
      />
    </Column>
  </Row>
);

CourseListFilter.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

export default CourseListFilter;
